<template>
  <PageTemplate>
    <v-sheet color="transparent" width="100%" class="item">
      <Loading v-if="loading" />

      <div v-else>
        <v-container class="pt-10 pb-12">
          <v-row justify="center" v-if="item.title">
            <v-col cols="12" lg="8">
              <div
                class="
                  secondary--text
                  text--darken-1 text-h5 text-sm-h4 text-md-h3 text-lg-h2
                  font-weight-bold
                "
              >
                {{ item.title }}
              </div>

              <iframe
                class="d-block mt-8 item-video"
                :src="`https://www.youtube.com/embed/${getYoutubeCode(
                  item.video
                )}`"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>

              <div
                class="secondary--text text--lighten-1 text-body-2 mt-10"
                v-if="item.text"
              >
                <span class="font--secondary" v-html="item.text"></span>
              </div>
            </v-col>
            <v-col class="mt-10 mt-lg-0" cols="12" lg="4">
              <LatestVideos :item-id="parseFloat(itemId)" />
            </v-col>
          </v-row>
          <v-alert v-else type="info" class="mt-10">
            Nenhum item adicionado até o momento.
          </v-alert>
        </v-container>
      </div>
    </v-sheet>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page";
import Loading from "../../widgets/Loading.vue";
import { getYoutubeCode } from "../../../utils/getYoutubeCode";
import LatestVideos from "../../widgets/LatestVideos.vue";

const _config = {
  mod: "videos",
};

export default {
  data: () => ({
    loading: true,
    item: {},
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    getYoutubeCode,
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    PageTemplate,
    Loading,
    LatestVideos,
  },
};
</script>

<style lang="scss" scoped>
.item-video {
  aspect-ratio: 16 / 9;
  width: 100%;
}
</style>
